import React, { memo } from "react";
import { AnimatePresence } from "framer-motion";

export const VisualArea = memo(({ children }: { children: React.ReactNode }) => {
    // const shouldBreakoutPadding = step === BuildSteps.PROMPT || step === BuildSteps.REVIEW;
    // const shouldEnforceBlackBackground = step === BuildSteps.REVIEW;

    return (
        <div
            className="relative flex h-full min-h-0 min-w-0 flex-1 items-center justify-center overflow-x-visible bg-transparent md:overflow-hidden"
            // shouldEnforceBlackBackground && "bg-gray-900",
            //shouldBreakoutPadding && "-mx-3 w-screen md:mx-0 md:w-full"
        >
            <AnimatePresence mode="wait">{children}</AnimatePresence>
        </div>
    );
});

VisualArea.displayName = "VisualArea";
